<template>
    <div>
        <table>
            <tr>
                <td>Consumable</td>
                <td>
                    <select v-model="settings.cons_type">
                        <option v-for="consumable in consumables" :value="consumable.id">{{consumable.label}}</option>
                    </select>
                    
                </td>
                <td>
                    Liquid detection
                </td>
                <td>
                    <p-check class="p-default p-curve" v-model="settings.liquiddetection"></p-check>
                </td>           
            </tr>
            <tr>
                <td>Solvent</td>
                <td>
                    <treeselect class="smalltreeselect" :disable-branch-nodes="true" placeholder="Select Solvent" :options="solvents" v-model="settings.tip_solv"/>
                </td>
                <td>Immersion depth</td>
                <td>
                    <vue-numeric 
                        thousand-separator="'" 
                        :precision="1" 
                        :min="2" 
                        :max="100" 
                        currency="mm" 
                        currency-symbol-position="suffix" 
                        decimal-separator="." 
                        v-model="settings.immersion"
                        :disabled="!settings.liquiddetection"
                    />
                </td>
            </tr>
            <tr>
                <td>
                    Volume
                </td>
                <td>
                    <vue-numeric 
                        thousand-separator="'" 
                        :precision="3" 
                        :min="0" 
                        :max="maxVolume" 
                        currency="ml" 
                        currency-symbol-position="suffix" 
                        decimal-separator="." 
                        v-model="settings.volume_solv"
                        :key="maxVolume"
                    /> <!-- HACK: vue-numeric doesnt update correctly when changing max. the key prop forces it to re-render. -->
                </td>     
                <td>
                    Min aspiration height
                </td>
                <td>
                    <vue-numeric 
                        thousand-separator="'" 
                        :precision="1" 
                        :min="0" 
                        :max="135" 
                        currency="mm" 
                        currency-symbol-position="suffix" 
                        decimal-separator="." 
                        v-model="settings.min_height"
                    />
                </td>
            </tr>
            <tr>
                <td>
                    Weighing
                </td>
                <td>
                    <p-check class="p-default p-curve" v-model="settings.weighing" :disabled="(settings.cons_type == 'SnapvialCons')"></p-check>
                </td>
                <td>Wash volume</td>
                <td>
                    <vue-numeric 
                        thousand-separator="'" 
                        :precision="2" 
                        :min="0.1" 
                        :max="50" 
                        currency="ml" 
                        currency-symbol-position="suffix" 
                        decimal-separator="." 
                        v-model="settings.wash_vol"
                    />
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import actionMixin from './action.mixin';

export default {
    mixins: [actionMixin],
    methods: {
    },
    props: [
        'lastsolvent'
    ],
    data: function(){return{
        solvents: this.$store.state.solvents.map(s=>({
            label: s.solventName,
            id: s.solventName
        })),
        consumables: [
            {id: 'ExCons',       label: 'accrotube'},
            {id: 'MiniCons',     label: 'accrotube mini'},
            {id: 'SnapvialCons', label: 'snapvial'},
        ]
    }},
    beforeMount: function(){
        Vue.set(this.settings, 'inputTypes', ['ExSample','MiniSample','SnapvialSample']);

        this.setDefault('cons_type', 'ExCons'); 
        this.setDefault('volume_solv', 0.1);
        this.setDefault('min_height', 5);
        this.setDefault('immersion', 5);
        this.setDefault('wash_vol', 3);
        this.setDefault('liquiddetection', true);
        this.setDefault('weighing', true);
        
    },
    watch: {
        'settings.cons_type': {
            immediate: true,
            handler(){
                Vue.set(this.settings, 'outputType', {
                    ExCons: 'ExSample',
                    MiniCons: 'MiniSample',
                    SnapvialCons: 'SnapvialSample',
                }[this.settings.cons_type]);
            }
        },
    },
    computed: {
        maxVolume(){
            return {
                ExCons: 50,
                MiniCons: 15,
                SnapvialCons: 1.6,
            }[this.settings.cons_type]
        }
    },
}

</script>

<style>
    
</style>

<style lang="scss" src="./action.scss" scoped>